import React from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Ticker from "@/components/site/Ticker";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Services from "@/components/site/Services";
import QuoteForm from "@/components/site/QuoteForm";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import WhatsappFloat from "@/components/site/WhatsappFloat";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative">
      <Header />
      <main>
        <Hero />
        <Ticker />
        <WhyChooseUs />
        <Services />
        <QuoteForm />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsappFloat />
    </div>
  );
}
